// extracted by mini-css-extract-plugin
module.exports = {"container":"_2e8bbdd1"};